import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pt-52 pb-20 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Mentions légales & Conditions générales
          </h1>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="space-y-12"
        >
          {/* 1. Mentions légales */}
          <div className="bg-gray-50 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              1. Mentions légales
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Éditeur du site :</strong> Advocaci Groupe
                <br />
                11 place de la Croix de Bourgogne
                <br />
                54000 Nancy, France
                <br />
                Téléphone : 01 83 79 02 87
                <br />
                Email : contact@formateurpouradulte.fr
              </p>
              <p>
                <strong>Directeur de la publication :</strong> Bruno GOSSELIN
              </p>
              <p>
                <strong>Hébergeur :</strong> Netlify -{" "}
                <a
                  href="https://www.netlify.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  https://www.netlify.com
                </a>
              </p>
              <p>
                <strong>SIRET :</strong> 820 245 793 00022
              </p>
              <p>
                <strong>Numéro de déclaration d'activité :</strong> 44540415554
              </p>
              <p>
                <strong>Code APE :</strong> 7021Z
              </p>
              <p>
                <strong>Propriété intellectuelle :</strong> L'ensemble des
                contenus présents sur le site (textes, images, logos, etc.) est
                protégé par le droit d'auteur. Toute reproduction ou
                représentation totale ou partielle du site, sans autorisation
                expresse, est interdite.
              </p>
            </div>
          </div>

          {/* 2. Politique de confidentialité (RGPD) */}
          <div className="bg-gray-50 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              2. Politique de confidentialité (RGPD)
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Responsable du traitement :</strong> Advocaci Groupe
                <br />
                11 place de la Croix de Bourgogne
                <br />
                54000 Nancy, France
              </p>
              <p>
                <strong>Données collectées :</strong> Nous collectons uniquement
                les données suivantes via le formulaire de contact : nom, email.
                Ces informations sont utilisées exclusivement pour répondre à
                vos demandes et gérer les inscriptions aux formations.
              </p>
              <div>
                <strong>Finalité :</strong> Les données sont traitées pour :
                <ul className="list-disc list-inside mt-2 ml-4">
                  <li>Répondre à vos demandes d'information.</li>
                  <li>Gérer les inscriptions aux formations.</li>
                </ul>
              </div>
              <p>
                <strong>Durée de conservation :</strong> Vos données sont
                conservées pendant 3 ans à compter de notre dernier échange.
              </p>
              <div>
                <strong>Droits des utilisateurs :</strong> Conformément au RGPD,
                vous disposez des droits suivants :
                <ul className="list-disc list-inside mt-2 ml-4">
                  <li>
                    Droit d'accès, de rectification, de suppression et
                    d'opposition.
                  </li>
                  <li>Droit à la portabilité de vos données.</li>
                </ul>
                <p className="mt-2">
                  Pour exercer ces droits, contactez-nous à l'adresse suivante :{" "}
                  <a
                    href="mailto:contact@formateurpouradulte.fr"
                    className="text-blue-600 hover:underline"
                  >
                    contact@formateurpouradulte.fr
                  </a>
                  .
                </p>
              </div>
              <p>
                <strong>Cookies :</strong> Ce site utilise uniquement des
                cookies techniques strictement nécessaires au fonctionnement du
                formulaire de contact. Aucune donnée n'est utilisée à des fins
                de suivi ou de marketing.
              </p>
              <p>
                <strong>Sécurité :</strong> Vos données sont stockées sur des
                serveurs sécurisés et ne sont pas transmises à des tiers, sauf
                obligation légale.
              </p>
            </div>
          </div>

          {/* 3. Conditions Générales d'Utilisation (CGU) */}
          <div className="bg-gray-50 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              3. Conditions Générales d'Utilisation (CGU)
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Objet :</strong> Les présentes Conditions Générales
                d'Utilisation (CGU) définissent les modalités d'accès et
                d'utilisation du site formateurpouradulte.fr.
              </p>
              <p>
                <strong>Responsabilités :</strong> L'utilisateur s'engage à
                utiliser le site de manière licite et à ne pas porter atteinte
                aux droits de tiers.
              </p>
              <p>
                <strong>Limitation de responsabilité :</strong> Advocaci Groupe
                ne saurait être tenu responsable des dommages indirects liés à
                l'utilisation du site.
              </p>
              <p>
                <strong>Modification des CGU :</strong> Les présentes conditions
                peuvent être modifiées à tout moment. Les utilisateurs en seront
                informés via une mise à jour sur le site.
              </p>
            </div>
          </div>

          {/* 4. Conditions Générales de Vente (CGV) */}
          <div className="bg-gray-50 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              4. Conditions Générales de Vente (CGV)
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                <strong>Objet :</strong> Les présentes Conditions Générales de
                Vente (CGV) s'appliquent à la vente de formations certifiantes
                proposées par Advocaci Groupe.
              </p>
              <p>
                <strong>Prix :</strong> Les prix sont indiqués en euros TTC.
              </p>
              <p>
                <strong>Modalités de paiement :</strong> Les paiements peuvent
                être effectués par carte bancaire, virement, CPF ou via un OPCO.
              </p>
              <p>
                <strong>Droit de rétractation :</strong> Conformément à
                l'article L.221-18 du Code de la consommation, vous disposez
                d'un délai de 14 jours pour vous rétracter, sauf si la formation
                a débuté avant l'expiration de ce délai.
              </p>
              <p>
                <strong>Remboursement :</strong> Les remboursements sont soumis
                aux conditions légales en vigueur.
              </p>
            </div>
          </div>

          {/* Back to home link */}
          <div className="text-center pt-8">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Retour à l'accueil
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MentionsLegales;
